import lang from '../../../../lib/language';
import { Earning } from '../../../../lib/models/fundamental/types';
import { formatNumberWithSuffix } from '../../../../lib/util/DataHelpers';

import { formatEarningsRevenue, formatPreviousReportDate } from './earningsReportHelpers';
import EarningsSurpriseValue from './EarningsSurpriseValue';

import styles from './PreviousReportsSection.module.scss';

type Props = {
  reports: Earning[];
  isLoading: boolean;
};

const SKELETON_ROW_KEYS = ['first', 'second', 'third'];

const renderReportRow = (report: Earning): JSX.Element => {
  const formattedRevenueSurprise = report.revenueSurprisePercent
    ? formatNumberWithSuffix(report.revenueSurprisePercent, '%')
    : '';

  return (
    <div className={styles.reportRow} key={`${report.symbol}-${report.date}`}>
      <div className={styles.leftColumn}>
        <div className={styles.periodLabel}>{formatPreviousReportDate(report.date)}</div>
        <div className={styles.revenueRow}>
          <span>{lang.earningsReportDetailsRevenue()}</span>
          <span className={styles.revenueValue}>
            {' '}{formatEarningsRevenue(report.revenue, report.currency, report.symbol)}
            {formattedRevenueSurprise && ` (${formattedRevenueSurprise})`}
          </span>
        </div>
      </div>
      <div className={styles.rightColumn}>
        <span className={styles.epsLabel}>{lang.earningsReportDetailsEpsSurprise()}</span>
        <EarningsSurpriseValue
          surprise={report.epsSurprise}
          surprisePercent={report.epsSurprisePercent}
          currency={report.currency}
          symbol={report.symbol}
        />
      </div>
    </div>
  );
};

const PreviousReportsSection = ({ reports, isLoading }: Props): JSX.Element | null => {
  if (!isLoading && !reports.length) return null;

  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>{lang.earningsReportDetailsPreviousReports()}</div>
      <div className={styles.card}>
        {isLoading
          ? SKELETON_ROW_KEYS.map(key => <div key={key} className={styles.skeletonRow} />)
          : reports.map(renderReportRow)}
      </div>
    </div>
  );
};

export default PreviousReportsSection;
